import { Inject, Injectable, LOCALE_ID } from '@angular/core';
import { map, Observable, of, pipe } from 'rxjs';
import { ApiService } from '../api/api.service';
import { PermissionsService } from '../permissions/permissions.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService {
  path = "checks/"

  constructor(
    private apiService: ApiService,
    private permissions: PermissionsService,
    @Inject(LOCALE_ID) private locale: string,
  ) { }

  getReport(uid: string | null): Observable<any> {
    const path = this.path+'exit/check/'+uid + `?language_locale=${this.locale.toLowerCase()}`;
    return this.apiService.get(path);
  }

  generateAndExportReport(data): Observable<any>{
    const endpoint = 'report/export';
    return this.apiService.post(endpoint, data).pipe(map(res => res['data']));
  }
}
